import * as _ from 'lodash';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { ERROR, CREATE } from '@/main/store/listEditTypes';
import { writeAction } from '@/main/store/actionsFunctions';
import { DepTables, EditStore, EditStoreProps } from '@/main/store/@types/edit.d';
import { Cell, Row } from '@/main/utils/table';

import { NdPrijemkaPolozky } from '../polozky';
import { NAME as name, DEPENDENT_TABLES as depTableNames, CRUMB_LABEL_KEY, DMS_MODULE, DOKLADY, NDPRIJEMKA_STATUS, PR_ORDER } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';
import { number } from '@storybook/addon-knobs';
import { stat } from 'fs';

const edit = {
	SkladOzn: null as number | null,
	Text: null as string | null,
	VyrobekndOzn: null as number | null,
	UzavreniDat: null as string | null,
	DodFaktNr: null as string | null,
	DodListNr: null as string | null,
	DodavatelId: null as number | null,
	DodavatelIdText: null as string | null,
	DealerId: null as number | null,
	DealerName: null as string | null,
	IsDealer: false as boolean | null,
	DokladId: null as number | null,
	EditDat: null as string | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	EdlPrp: null as number | null,
	JednotekCil: null as number | null,
	JednotekZdr: null as number | null,
	MenaIdCil: null as number | null,
	MenaIdZdr: null as number | null,
	NcCelkPrp: null as boolean | null,
	NcKontrsouc: null as number | null,
	NcKorDat: null as string | null,
	NdpohybdoklId: null as number | null,
	NdprijemPzn: null as number | null,
	ObjednNr: null as number | null,
	ObjednVyrOzn: null as string | null,
	PozadavekDruh: null as string | null,
	PrijemkaId: null as number | null,
	PrijemkaNr: null as number | null,
	PrijemkaPfx: null as string | null,
	Status: null as NDPRIJEMKA_STATUS | null,
	StatusText: null as string | null,
	VstupDat: null as string | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	VyrazenDat: null as string | null,
	EdlFileType: null as string | null | string[],
	Edl: null as boolean | null,
	EdlId: null as number | null,
	EdlTableRows: null as object | null,
	CanMakeDobropis: null as boolean | null,
	PrOrderId: null as number | null,
	IsFromPROrderload: null as boolean | null,
	PRInvoiceFlag: null as boolean | null,
	PRInvoiceNr: null as number | null,
	PRInvoicePfx: null as string | null,
	PRInvoiceId: null as number | null,
	PRInvoiceDate: null as string | null,
	Remarks: null as string | null,
	Discount: null as number | null,
	DiscAfterCalc: null as number | null,
	PriceAfterDisc: null as number | null,
	TotalPrice: null as number | null,
	ExpiryDat: null as Date | null,
	MioId: null as number | null,
	MioText: null as string | null,
	MioNDNr: null as number | null,
	Quantity: null as number | null,
	GstAmt: null as number | null,
	TotalPriceAfterDiscWithGst: null as number | null,
	VatAmt: null as number | null,
	TotalPriceAfterDiscWithVat: null as number | null,
	PrInvoicePaymentId: null as number | null,
	LrNo: null as string | null,
	OrderType: null as string | null,
	NdPrijemkaPolozky: [] as any[] | null,
	IsGRNClosed: null as boolean | null,
	PROrderIds: [] as any[] | null,
	BillToWarehouseId: null as number | null,
	BillToWareHouseName: null as string | null,
	ShipToWareHouseName: null as string | null,
};

const dropdownList = {
	NdprijemPzn: [],
	MenaId: [],
};

const localState = {
	NdPrijemDto: null as object | null,
	showRefresh: false as boolean | null,
};

type State = EditStore<typeof edit, typeof dropdownList, typeof localState, DepTables<typeof depTableNames>, EditStoreProps>;

const SaveNdPrijemkaPolozky = async (state: State, prijemkaId: number) => {
	const ndPrijemkaPolozky = state.dependentTables.NdPrijemkaPolozky.rows.reduce(
		(polozky: Cell[], row: Row) => {
			const polozka = _.find(row.cells, (cell: any) => typeof cell === 'object' && cell)!;

			polozka.PrijemkaId = prijemkaId;
			return [...polozky, polozka];
		},
		[] as Cell[],
	);

	await apiProvider.insertEdlPolozky(ndPrijemkaPolozky);
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	edit,
	localState,
	depTableNames,
	depTableSettings: {
		[NdPrijemkaPolozky.name]: { 
			isEditable: true, 
			columns: {
				//LEFT_PART_QUANTITY:{ isEditable: true, required: true, type: 'decimal', minWidth: '120', },	
				TEXT:{isEditable: true, required: false, type: 'text', minWidth: '120',},
				REMARK:{isEditable: true, required: false, type: 'text', minWidth: '120',},
				UNIT_COST_PRICE:{isEditable: true, required: false, type: 'decimal', minWidth: '120', },
				RECEIPT_QUANTITY:{isEditable: true, required: false, type: 'decimal', minWidth: '120', },
				DISCOUNT_PCT:{isEditable: true, required: false, type: 'decimal', minWidth: '120', },
			},
			filter(state) { return { PROrderId: state.edit.PrOrderId ? state.edit.PrOrderId : 0, PrijemkaId: state.edit.PrijemkaId }; } 
		},
		[DOKLADY]: { filter(state) { return { PrijemkaId: state.edit.PrijemkaId }; } },
		[PR_ORDER]: { filter(state) { return { LoggedUserId:  0, SupplierId: state.edit.DodavatelId};} },
	},
	extraActions: {
		async [CREATE]({ commit, dispatch, state }, { goBack = true }) {
			const polozkyRowCount = state.dependentTables.NdPrijemkaPolozky.rows.length;
			try {
				const createResult = await apiProvider.createEntity(state.edit);
				const prijemkaId = createResult.headers.location.split('=')[1];
				console.log(state.edit);
				if (polozkyRowCount) {
					await SaveNdPrijemkaPolozky(state, prijemkaId);
				}
				if (!goBack) {
					return writeAction(
						state,
						commit,
						dispatch,
						apiProvider.entity(prijemkaId),
						goBack,
					);
				}
				return createResult;
			} catch (err) {
				return dispatch(ERROR, { DMS_MODULE, err }, { root: true });
			}
		},
	},
	extraGetters: {},
	extraMutations: {
		[editMutations.ND_PRIJEMKA_DODAVATEL_SELECT_MAPPER](state, { data }) {
			state.edit.DodavatelId = data.value;
			state.edit.DodavatelIdText = data.text;
		},
		[editMutations.ND_PRIJEMKA_NDOBJEDNAVKA_SELECT_MAPPER](state, { data }) {
			state.edit.MioId = data.value;
			state.edit.MioText = data.text;
			state.edit.Quantity = data.MNOZSTVI_OBJ;
			state.edit.MioNDNr = data.ND_NR;
		},
		[editMutations.ND_PRIJEMKA_PRORDERS_SELECT_MAPPER](state, { data }) {
			state.edit.PrOrderId = data.value;
			state.edit.DodavatelId = data.DodavatelId;
			state.edit.DodavatelIdText = data.DodavatelIdText;
			state.edit.DealerId = data.DealerId;
			state.edit.DealerName = data.DealerName;
			state.edit.OrderType = data.OrderType;
			state.edit.IsDealer = data.IsDealer;
			state.edit.SkladOzn = data.SkladOzn == null ? state.edit.SkladOzn : data.SkladOzn;
			state.localState.showRefresh = true;
		},
		[editMutations.ND_PRIJEMKA_DEALER_SELECT_MAPPER](state, { data }) {
			state.edit.DealerId = data.value;
			state.edit.DealerName = data.text;
		},
	},
	props: {
		mode: null,
		isZpracujMode: false,
	},
});
